import React from 'react'

export const honeyGenerator = (stringLength = 8) => {
  return [...Array(stringLength)]
    .map(() => Math.random().toString(36)[2])
    .join('')
}

const Honey: React.FC<{
  validRef: React.RefObject<HTMLInputElement>,
  formId?: string
}> = ({ validRef, formId }) => {
  const honeyHash = typeof formId === "string" && formId.length > 0 ? formId : honeyGenerator();
  const potId = `IsValid${honeyHash}`;

  // Honeypot behavior to catch when bots submit a form, because they fill it all out.
  return (
    <>
      <input
        type="checked"
        id={potId}
        name={potId}
        placeholder="Your validity"
        autoComplete="off"
        ref={validRef}
        hidden
      />
    </>
  )
}

export default Honey
